import { useEffect, useState } from 'react';
import styles from "./ShutterSurfaces.module.css";

export default function ShutterSurfaces({packageId,packageData, handleSurfaceSelect}) {
    const [selectedSurface, setSelectedSurface] = useState(null);

    useEffect(() => {
        // Select the first surface by default whenever the package data changes
        if (packageData && packageData.garageDoor) {
            const firstSurface = packageData.shutters.split(',')[0];
            setSelectedSurface(firstSurface);
            handleSurfaceSelect({ target: { value: firstSurface, getAttribute: () => 'SHUTTERS' } });
        }
    }, [packageData]);
    
    const surfaces = packageData != null ? (
        packageData.shutters.split(',').map((surface, index) => (
            <li key={`${index}`}>
                <label htmlFor={index}>{surface}</label>
                <input
                    type="radio"
                    name="shutterSurfaces"
                    id={index}
                    data-surface-name="SHUTTERS"
                    value={surface}
                    onChange={(e) => {
                        setSelectedSurface(surface);
                        handleSurfaceSelect(e);
                    }}
                    aria-label="surface selector"
                    checked={surface === selectedSurface}
                />
            </li>
        ))
    ) : (
        <li>No surfaces</li>
    );

    return (
        <div className={styles.content}>
            <p>Shutters:</p>
            <ul>
                {surfaces.length ? surfaces : <li>No surfaces</li>}
            </ul>
        </div>
    );
}
